var layoutStyles = {"column":"modal__column_knva0","gap-16":"modal__gap-16_knva0","gap-24":"modal__gap-24_knva0","gap-32":"modal__gap-32_knva0","start":"modal__start_knva0","center":"modal__center_knva0","space-between":"modal__space-between_knva0"};
require('./components/footer/layout.css');

exports.layoutStyles = layoutStyles;
